import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeftDouble20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCaretLeftDouble20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.53 4.53a.75.75 0 1 0-1.06-1.06l-6 6-.53.53.53.53 6 6a.75.75 0 0 0 1.06-1.06L11.06 10zm-6 0a.75.75 0 1 0-1.06-1.06l-6 6-.53.53.53.53 6 6a.75.75 0 0 0 1.06-1.06L5.06 10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeftDouble20);
